export default __webpack_public_path__ + "static/media/icon-kepler.3ebe0d2a.svg";